import React, { useEffect, useRef, useState } from "react";

const Icon = ({ d, size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={1.8} strokeLinecap="round"
    strokeLinejoin="round" className={className}>
    <path d={d} />
  </svg>
);
const ICONS = {
  check: "M20 6L9 17l-5-5",
  x:     "M18 6L6 18M6 6l12 12",
  whatsapp: "M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z",
};

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700;800&family=JetBrains+Mono:wght@400;600&display=swap');

  .vp-title {
    background: linear-gradient(110deg, #fbbf24 35%, #a78bfa 50%, #fbbf24 65%);
    background-size: 200% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: vp-shimmer 8s linear infinite;
  }

  @keyframes jdc-gradient-shift {
    0%, 100% { background-position: 0% 50%; }
    50%       { background-position: 100% 50%; }
  }
  .jdc-divider {
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(249,115,22,0.4) 20%, rgba(168,85,247,0.5) 50%, rgba(6,182,212,0.4) 80%, transparent);
  }
  @keyframes jdc-fadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .jdc-fade   { animation: jdc-fadeUp 0.6s ease forwards; }
  .jdc-fade-1 { animation-delay: 0.1s; opacity: 0; }
  .jdc-fade-2 { animation-delay: 0.2s; opacity: 0; }
  .jdc-fade-3 { animation-delay: 0.3s; opacity: 0; }
  .jdc-fade-4 { animation-delay: 0.4s; opacity: 0; }
  .jdc-fade-5 { animation-delay: 0.5s; opacity: 0; }

  @keyframes jdc-highlight-bg {
    0%, 100% { background-position: 0% 50%; }
    50%       { background-position: 100% 50%; }
  }
  .jdc-highlight-bg { background-size: 200% 200%; animation: jdc-highlight-bg 8s ease infinite; }

  @keyframes jdc-speed-pulse {
    0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(249,115,22,0.7); }
    50%       { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(249,115,22,0); }
  }
  .jdc-speed-badge { animation: jdc-speed-pulse 2.5s ease-in-out infinite; }

  .jdc-feature-card { transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1); }
  .jdc-feature-card:hover { transform: translateY(-10px) scale(1.03); }

  .jdc-badge { transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); }
  .jdc-badge:hover { transform: translateY(-4px) scale(1.05); }
  @keyframes jdc-badge-pop {
    0%   { transform: scale(0.8); opacity: 0; }
    100% { transform: scale(1); opacity: 1; }
  }
  .jdc-badge-anim { animation: jdc-badge-pop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) backwards; }

  .jdc-bento-card { transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1); }
  .jdc-bento-card:hover { transform: translateY(-6px); }

  /* ── Bento accent animations ── */
  @keyframes ody-scan-sweep {
    0%   { transform: translateY(0);    opacity: 1; }
    90%  { opacity: 0.6; }
    100% { transform: translateY(46px); opacity: 0; }
  }
  .ody-scan { animation: ody-scan-sweep 2.2s ease-in-out infinite; }

  @keyframes ody-bar-grow {
    0%   { width: 0%; }
    60%  { width: 100%; }
    100% { width: 100%; }
  }
  .ody-opt-bar { animation: ody-bar-grow 2.4s ease-out infinite; }

  @keyframes ody-ring-progress {
    from { stroke-dashoffset: 88; }
    to   { stroke-dashoffset: 14; }
  }
  .ody-progress-ring { stroke-dasharray: 88; animation: ody-ring-progress 2s cubic-bezier(0.22,1,0.36,1) infinite alternate; }

  @keyframes ody-path-draw {
    from { stroke-dashoffset: 130; }
    to   { stroke-dashoffset: 0; }
  }
  .ody-path { stroke-dasharray: 130; animation: ody-path-draw 2.5s cubic-bezier(0.22,1,0.36,1) infinite alternate; }

  @keyframes ody-node-pulse {
    0%, 100% { opacity: 0.4; }
    50%       { opacity: 1; }
  }
  .ody-node { animation: ody-node-pulse 2s ease-in-out infinite; }

  /* ── Process flow accent animations ── */

  /* ASSESS — resume with animated scan highlighting gaps */
  @keyframes ody-resume-scan {
    0%   { transform: translateY(0);    opacity: 1; }
    100% { transform: translateY(48px); opacity: 0; }
  }
  .ody-res-scan { animation: ody-resume-scan 2.2s ease-in-out infinite; }

  @keyframes ody-gap-flash {
    0%, 100% { fill: rgba(251,146,60,0.15); }
    50%       { fill: rgba(251,146,60,0.55); }
  }
  .ody-gap-bar { animation: ody-gap-flash 1.5s ease-in-out infinite; }

  /* ENHANCE — bars growing upward = score improvement */
  @keyframes ody-bar-rise {
    from { height: 0; y: 48; }
    to   { }
  }
  .ody-rise-1 { animation: ody-bar-up 2s ease-out 0.0s infinite alternate; }
  .ody-rise-2 { animation: ody-bar-up 2s ease-out 0.2s infinite alternate; }
  .ody-rise-3 { animation: ody-bar-up 2s ease-out 0.4s infinite alternate; }
  .ody-rise-4 { animation: ody-bar-up 2s ease-out 0.6s infinite alternate; }

  @keyframes ody-bar-up {
    from { transform: scaleY(0); opacity: 0; }
    to   { transform: scaleY(1); opacity: 1; }
  }

  /* PRACTICE — dialogue bubbles appearing alternately */
  @keyframes ody-bubble-a {
    0%, 30% { opacity: 0; transform: scale(0.8) translateY(4px); }
    40%, 70% { opacity: 1; transform: scale(1) translateY(0); }
    80%, 100% { opacity: 0; }
  }
  @keyframes ody-bubble-b {
    0%, 45% { opacity: 0; transform: scale(0.8) translateY(4px); }
    55%, 85% { opacity: 1; transform: scale(1) translateY(0); }
    95%, 100% { opacity: 0; }
  }
  .ody-bbl-a { animation: ody-bubble-a 3s ease-in-out infinite; }
  .ody-bbl-b { animation: ody-bubble-b 3s ease-in-out infinite; }

  /* DECIDE — offer scale balancing */
  @keyframes ody-scale-tilt {
    0%, 100% { transform: rotate(0deg); }
    50%       { transform: rotate(-5deg); }
  }
  .ody-scale-beam { animation: ody-scale-tilt 3s ease-in-out infinite; transform-origin: 34px 22px; }

  .ody-process-card { transition: all 0.3s ease; }
  .ody-process-card:hover { transform: translateY(-6px); }

  /* ── Comparison ── */
  .jdc-comparison-card { position: relative; overflow: hidden; transition: all 0.3s ease; }
  .jdc-comparison-card::before {
    content: ''; position: absolute; top: 0; left: -100%; width: 100%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.03), transparent);
    transition: left 0.5s ease;
  }
  .jdc-comparison-card:hover::before { left: 100%; }
  .jdc-comparison-card:hover { transform: translateY(-4px); }
  .jdc-comparison-item { transition: all 0.2s ease; }
  .jdc-comparison-item:hover { transform: translateX(4px); }
  @keyframes jdc-check-pop {
    0%   { transform: scale(0); opacity: 0; }
    50%  { transform: scale(1.2); }
    100% { transform: scale(1); opacity: 1; }
  }
  .jdc-check-icon { animation: jdc-check-pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) backwards; }
  .jdc-x-icon:hover { animation: jdc-x-shake 0.4s ease-in-out; }
  @keyframes jdc-x-shake {
    0%, 100% { transform: rotate(0deg); }
    25%       { transform: rotate(-3deg); }
    75%       { transform: rotate(3deg); }
  }

  /* ── Timeline ── */
  @keyframes ody-tl-line-grow {
    from { transform: scaleX(0); }
    to   { transform: scaleX(1); }
  }
  .ody-h-timeline-line { animation: ody-tl-line-grow 2.2s cubic-bezier(0.22,1,0.36,1) 0.4s both; transform-origin: left; }

  @keyframes ody-glow-pulse {
    0%, 100% { opacity: 0.2; }
    50%       { opacity: 0.6; }
  }
  .ody-glow { animation: ody-glow-pulse 3s ease-in-out infinite; }

  .ody-tl-card { transition: all 0.3s ease; }
  .ody-tl-card:hover { transform: translateY(-8px); }

  @keyframes jdc-timeline-draw {
    from { height: 0%; }
    to   { height: 100%; }
  }
  .jdc-timeline-line { animation: jdc-timeline-draw 1.5s cubic-bezier(0.22, 1, 0.36, 1) 0.3s both; }
  .jdc-timeline-card { transition: all 0.3s ease; }
  .jdc-timeline-card:hover { transform: translateX(6px); }
`;

// ─── DATA ─────────────────────────────────────────────────────────────────────
const BADGES = [
  "Resume Scoring","Skill Gap Detection","Keyword Optimization",
  "Job Match %","Interview Story Builder","Salary Benchmarking",
  "Offer Risk Analysis","Career Path Forecasting",
];
const FEATURES = [
  { icon: "📄", title: "Resume Intelligence", text: "Audit your resume for ATS compatibility, keyword gaps, and impact clarity — then receive a structured rewrite roadmap that positions you for the roles you're targeting.", color: "orange" },
  { icon: "🎯", title: "Job Fit Scoring", text: "Decode any job description against your profile — get a precise match score, a ranked gap analysis, and tailoring guidance before you hit apply.", color: "violet" },
  { icon: "🗺️", title: "Career Path Intelligence", text: "Map realistic progression routes from where you are to where you want to be — with skill milestones, transition timelines, and market-validated role pathways.", color: "cyan" },
  { icon: "🎙️", title: "Interview Readiness", text: "Predict role-specific interview questions, build structured story-driven answers using proven frameworks, and rehearse with AI-powered mock interview sessions.", color: "emerald" },
  { icon: "✍️", title: "Narrative & Positioning", text: "Generate targeted cover letters, LinkedIn positioning, and professional summaries — all calibrated to the role, company tone, and your unique career story.", color: "amber" },
  { icon: "📊", title: "Offer Decision Intelligence", text: "Evaluate every compensation package against live market benchmarks, role growth signals, and your long-term trajectory — so no offer decision is made on instinct alone.", color: "pink" },
];
const FLOW_STEPS = [
  { label:"ASSESS",   color:"#fb923c", description:"Upload your resume and target role. Get a structured gap analysis across skills, keywords, and positioning signals." },
  { label:"ENHANCE",  color:"#a78bfa", description:"AI rewrites and optimizes your resume, cover letter, and profile for maximum role relevance and ATS performance." },
  { label:"PRACTICE", color:"#22d3ee", description:"Prepare with predicted interview questions, structured answer frameworks, and mock simulation feedback." },
  { label:"DECIDE",   color:"#34d399", description:"Evaluate offers with salary benchmarking, risk signals, and career trajectory analysis — and move forward with confidence." },
];
const COMPARISON = {
  title: "Career Guesswork vs. Structured Career Intelligence",
  beforeTitle: "Without Odyssey",
  afterTitle: "With HEKA Odyssey",
  before: [
    "Generic resumes sent blindly — no targeting, no strategy",
    "Rejected with no visibility into why or what to fix",
    "Interview prep built on anxiety, not structure",
    "Offer decisions made on gut feel without market context",
    "Career moves driven by urgency — not direction or data",
  ],
  after: [
    "Precision-optimized resume and LinkedIn — role by role, keyword by keyword",
    "Exact JD match score with a ranked, actionable gap analysis",
    "Role-predicted questions with structured, story-driven answer frameworks",
    "Every offer benchmarked against live market data and your trajectory",
    "A mapped career path with skill milestones and transition timelines",
  ],
};
const TIMELINE_STEPS = [
  { step: "01", title: "Audit Your Starting Point", subtitle: "Resume Analyzer · ATS Scanner", text: "Diagnose your resume for ATS compatibility failures, keyword gaps, and weak impact statements — before a single recruiter sees it.", color: "#f97316", nodeColor: "#f97316", glowColor: "rgba(249,115,22,0.12)", border: "rgba(249,115,22,0.25)" },
  { step: "02", title: "Optimize Your Positioning", subtitle: "Resume Optimizer · LinkedIn Optimizer", text: "Rewrite your resume and LinkedIn profile with precision targeting — aligned to the roles you want, not the roles you've had.", color: "#a855f7", nodeColor: "#a855f7", glowColor: "rgba(168,85,247,0.12)", border: "rgba(168,85,247,0.25)" },
  { step: "03", title: "Target With Precision", subtitle: "JD Decoder · Application Fit Score", text: "Decode every job description against your profile — score your fit, identify the gaps that matter, and apply only where you're positioned to win.", color: "#22d3ee", nodeColor: "#22d3ee", glowColor: "rgba(34,211,238,0.12)", border: "rgba(34,211,238,0.25)" },
  { step: "04", title: "Prepare & Perform", subtitle: "Interview Simulator · Story Builder", text: "Rehearse with role-predicted questions, build structured STAR-driven answers, and walk into every interview with a practiced, confident narrative.", color: "#10b981", nodeColor: "#10b981", glowColor: "rgba(16,185,129,0.12)", border: "rgba(16,185,129,0.25)" },
  { step: "05", title: "Decide With Clarity", subtitle: "Offer Analyzer · Career Path Mapper", text: "Evaluate every offer against live market benchmarks, role growth signals, and your long-term trajectory — so the right move is always data-backed.", color: "#f59e0b", nodeColor: "#f59e0b", glowColor: "rgba(245,158,11,0.12)", border: "rgba(245,158,11,0.25)" },
];

// ─── BENTO ACCENT SVGs ────────────────────────────────────────────────────────
// Students: Resume scan — glowing line sweeping document
const AccentStudents = () => (
  <svg width="80" height="60" viewBox="0 0 80 60">
    <rect x="10" y="4" width="38" height="50" rx="3" fill="none" stroke="rgba(251,146,60,0.3)" strokeWidth="1.5"/>
    {[0,1,2,3,4].map(i=>(
      <rect key={i} x="16" y={12+i*8} width={[28,20,32,18,24][i]} height="4" rx="2" fill="rgba(251,146,60,0.22)"/>
    ))}
    {/* ATS gap highlight — flashing bar */}
    <rect x="16" y="28" width="32" height="4" rx="2" className="ody-gap-bar"/>
    {/* Scan line */}
    <rect x="10" y="4" width="38" height="2.5" rx="1" fill="rgba(251,146,60,0.95)" className="ody-res-scan"
      style={{filter:"drop-shadow(0 0 3px rgba(251,146,60,0.8))"}}/>
    {/* Score badge */}
    <rect x="54" y="18" width="20" height="16" rx="3" fill="rgba(251,146,60,0.1)" stroke="rgba(251,146,60,0.4)" strokeWidth="1"/>
    <text x="64" y="29" textAnchor="middle" fill="rgba(251,146,60,0.9)" fontSize="7" fontFamily="monospace" fontWeight="bold">ATS</text>
  </svg>
);

// Mid-Level: Optimisation bars growing (before → after improvement)
const AccentMidLevel = () => (
  <svg width="80" height="60" viewBox="0 0 80 60">
    {[0,1,2,3].map(i=>{
      const maxW=[36,28,44,32][i];
      return (
        <g key={i}>
          <rect x="10" y={10+i*12} width="56" height="8" rx="3" fill="rgba(168,85,247,0.07)"/>
          {/* Before bar (dimmer, shorter) */}
          <rect x="10" y={10+i*12} width={maxW*0.55} height="8" rx="3" fill="rgba(168,85,247,0.2)"/>
          {/* After bar (full, animated) */}
          <rect x="10" y={10+i*12} width="0" height="8" rx="3" fill="rgba(168,85,247,0.55)" className="ody-opt-bar"
            style={{animationDelay:`${i*0.2}s`, maxWidth:`${maxW}px`}}/>
          <text x="70" y={17+i*12} fill="rgba(168,85,247,0.65)" fontSize="6.5" fontFamily="monospace">{[78,63,91,74][i]}%</text>
        </g>
      );
    })}
  </svg>
);

// Career Switchers: Match % ring
const AccentCareerSwitch = () => (
  <svg width="80" height="60" viewBox="0 0 80 60">
    <circle cx="40" cy="30" r="22" fill="none" stroke="rgba(34,211,238,0.1)"  strokeWidth="7"/>
    <circle cx="40" cy="30" r="22" fill="none" stroke="rgba(34,211,238,0.65)" strokeWidth="7"
      strokeLinecap="round" className="ody-progress-ring"
      style={{transform:"rotate(-90deg)", transformOrigin:"40px 30px"}}/>
    <text x="40" y="27" textAnchor="middle" fill="rgba(34,211,238,0.9)"  fontSize="12" fontFamily="monospace" fontWeight="bold">84%</text>
    <text x="40" y="38" textAnchor="middle" fill="rgba(34,211,238,0.5)"  fontSize="6.5" fontFamily="monospace">MATCH</text>
  </svg>
);

// Senior Leaders: Career path progression upward
const AccentSenior = () => (
  <svg width="80" height="60" viewBox="0 0 80 60">
    <path d="M10,54 C20,54 20,40 32,40 C44,40 44,26 56,26 C64,26 68,18 72,14"
      fill="none" stroke="rgba(16,185,129,0.55)" strokeWidth="2" strokeLinecap="round" className="ody-path"/>
    {[[10,54],[32,40],[56,26],[72,14]].map(([x,y],i)=>(
      <circle key={i} cx={x} cy={y} r="4.5" fill="rgba(16,185,129,0.12)"
        stroke="rgba(16,185,129,0.6)" strokeWidth="1.5" className="ody-node"
        style={{animationDelay:`${i*0.3}s`}}/>
    ))}
    <path d="M68,10 L74,15 L68,20" fill="none" stroke="rgba(16,185,129,0.75)"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ─── PROCESS FLOW ACCENT SVGs ─────────────────────────────────────────────────
// ASSESS — resume document with highlighted gap rows
const PfAssess = () => (
  <svg width="68" height="56" viewBox="0 0 68 56">
    <rect x="8" y="4" width="38" height="48" rx="3" fill="rgba(251,146,60,0.06)" stroke="rgba(251,146,60,0.3)" strokeWidth="1.5"/>
    {[0,1,2,3,4].map(i=>(
      <rect key={i} x="14" y={10+i*8} width={[28,20,32,14,24][i]} height="4" rx="2" fill="rgba(251,146,60,0.25)"/>
    ))}
    {/* Two "gap" rows highlighted */}
    <rect x="14" y="18" width="32" height="4" rx="2" fill="rgba(251,146,60,0)" stroke="rgba(251,146,60,0.7)" strokeWidth="1" strokeDasharray="3,2" className="ody-gap-bar"/>
    <rect x="14" y="34" width="32" height="4" rx="2" fill="rgba(251,146,60,0)" stroke="rgba(251,146,60,0.7)" strokeWidth="1" strokeDasharray="3,2" className="ody-gap-bar" style={{animationDelay:"0.4s"}}/>
    {/* Scan line */}
    <rect x="8" y="4" width="38" height="2" rx="1" fill="rgba(251,146,60,0.9)" className="ody-res-scan"
      style={{filter:"drop-shadow(0 0 2px rgba(251,146,60,0.7))"}}/>
    {/* Gap label */}
    <text x="54" y="22" fill="rgba(251,146,60,0.65)" fontSize="6.5" fontFamily="monospace">GAP</text>
    <text x="54" y="38" fill="rgba(251,146,60,0.65)" fontSize="6.5" fontFamily="monospace">GAP</text>
  </svg>
);

// ENHANCE — four vertical bars growing upward (score improvement)
const PfEnhance = () => (
  <svg width="68" height="56" viewBox="0 0 68 56">
    {/* Baseline */}
    <line x1="8" y1="50" x2="60" y2="50" stroke="rgba(167,139,250,0.3)" strokeWidth="1"/>
    {[0,1,2,3].map(i=>{
      const heights=[28,20,36,24][i];
      const x=14+i*13;
      return (
        <g key={i}>
          {/* Before (dim short bar) */}
          <rect x={x} y={50-heights*0.45} width="8" height={heights*0.45} rx="2"
            fill="rgba(167,139,250,0.2)" stroke="rgba(167,139,250,0.25)" strokeWidth="1"/>
          {/* After (full bar, grows from bottom) */}
          <rect x={x} y={50-heights} width="8" height={heights} rx="2"
            fill="rgba(167,139,250,0.5)" stroke="rgba(167,139,250,0.6)" strokeWidth="1"
            className={`ody-rise-${i+1}`} style={{transformOrigin:`${x+4}px 50px`}}/>
        </g>
      );
    })}
    <text x="34" y="10" textAnchor="middle" fill="rgba(167,139,250,0.65)" fontSize="6.5" fontFamily="monospace">OPTIMIZED</text>
  </svg>
);

// PRACTICE — two dialogue bubbles alternating (question / answer)
const PfPractice = () => (
  <svg width="68" height="56" viewBox="0 0 68 56">
    {/* Interviewer bubble (top left) */}
    <g className="ody-bbl-a">
      <rect x="4" y="4" width="40" height="18" rx="4" fill="rgba(34,211,238,0.12)" stroke="rgba(34,211,238,0.45)" strokeWidth="1.5"/>
      <path d="M8,22 L4,28 L14,22 Z" fill="rgba(34,211,238,0.12)" stroke="rgba(34,211,238,0.45)" strokeWidth="1"/>
      <rect x="8"  y="9"  width="22" height="3" rx="1.5" fill="rgba(34,211,238,0.5)"/>
      <rect x="8"  y="15" width="16" height="3" rx="1.5" fill="rgba(34,211,238,0.35)"/>
    </g>
    {/* Candidate bubble (bottom right) */}
    <g className="ody-bbl-b">
      <rect x="24" y="32" width="40" height="18" rx="4" fill="rgba(167,139,250,0.12)" stroke="rgba(167,139,250,0.45)" strokeWidth="1.5"/>
      <path d="M60,32 L64,26 L54,32 Z" fill="rgba(167,139,250,0.12)" stroke="rgba(167,139,250,0.45)" strokeWidth="1"/>
      <rect x="28" y="37" width="28" height="3" rx="1.5" fill="rgba(167,139,250,0.5)"/>
      <rect x="28" y="43" width="20" height="3" rx="1.5" fill="rgba(167,139,250,0.35)"/>
    </g>
  </svg>
);

// DECIDE — balance scale comparing two offers
const PfDecide = () => (
  <svg width="68" height="56" viewBox="0 0 68 56">
    {/* Vertical post */}
    <line x1="34" y1="10" x2="34" y2="50" stroke="rgba(52,211,153,0.4)" strokeWidth="1.5"/>
    {/* Base */}
    <rect x="22" y="48" width="24" height="5" rx="2" fill="rgba(52,211,153,0.15)" stroke="rgba(52,211,153,0.4)" strokeWidth="1"/>
    {/* Beam */}
    <g className="ody-scale-beam">
      <line x1="10" y1="22" x2="58" y2="22" stroke="rgba(52,211,153,0.65)" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="34" cy="22" r="3" fill="rgba(52,211,153,0.6)"/>
    </g>
    {/* Left pan */}
    <rect x="4"  y="34" width="16" height="10" rx="2" fill="rgba(52,211,153,0.1)" stroke="rgba(52,211,153,0.4)" strokeWidth="1"/>
    <line x1="10" y1="34" x2="10" y2="24" stroke="rgba(52,211,153,0.35)" strokeWidth="1"/>
    <line x1="18" y1="34" x2="18" y2="24" stroke="rgba(52,211,153,0.35)" strokeWidth="1"/>
    {/* Right pan */}
    <rect x="48" y="30" width="16" height="10" rx="2" fill="rgba(52,211,153,0.18)" stroke="rgba(52,211,153,0.55)" strokeWidth="1"/>
    <line x1="54" y1="30" x2="54" y2="24" stroke="rgba(52,211,153,0.35)" strokeWidth="1"/>
    <line x1="62" y1="30" x2="62" y2="24" stroke="rgba(52,211,153,0.35)" strokeWidth="1"/>
    {/* Checkmark on right pan */}
    <path d="M51,35 L54,39 L62,31" fill="none" stroke="rgba(52,211,153,0.85)" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);



const FeatureGrid = () => (
  <section className="jdc-fade jdc-fade-2">
    <div className="text-center mb-14">
      <p className="text-xs font-bold tracking-widest uppercase text-orange-400 mb-3">Platform Capabilities</p>
      <h2 className="text-3xl font-bold text-slate-100 tracking-tight">The Full Stack of Career Intelligence</h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {FEATURES.map((f,i)=>(
        <div key={i} className={`jdc-feature-card rounded-2xl border border-${f.color}-800/30 bg-gradient-to-br from-${f.color}-900/10 to-slate-900/50 p-7 hover:border-${f.color}-700/50 backdrop-blur-sm group`}>
          <div className="text-5xl mb-5">{f.icon}</div>
          <h3 className={`text-${f.color}-400 font-bold text-lg mb-3 tracking-tight group-hover:text-${f.color}-300 transition-colors`}>{f.title}</h3>
          <p className="text-slate-400 text-sm leading-relaxed group-hover:text-slate-300 transition-colors">{f.text}</p>
        </div>
      ))}
    </div>
  </section>
);

const BadgePills = () => (
  <section className="jdc-fade jdc-fade-3">
    <div className="text-center mb-12">
      <p className="text-xs font-bold tracking-widest uppercase text-violet-400 mb-3">Intelligence Modules</p>
      <h2 className="text-3xl font-bold text-slate-100 tracking-tight">Every Dimension of Your Career, Covered</h2>
    </div>
    <div className="flex flex-wrap gap-3 justify-center max-w-4xl mx-auto">
      {BADGES.map((b,i)=>(
        <div key={i} className="jdc-badge jdc-badge-anim px-5 py-2.5 rounded-full bg-gradient-to-r from-orange-900/30 to-amber-900/30 border border-orange-700/40 text-orange-300 text-sm font-semibold backdrop-blur-sm hover:border-orange-500/60 hover:text-orange-200 cursor-default"
          style={{animationDelay:`${i*0.05}s`}}>{b}</div>
      ))}
    </div>
  </section>
);

// ── BENTO: accent above content — no absolute positioning, no overlap ─────────
const BentoCards = () => (
  <section className="jdc-fade jdc-fade-3">
    <div className="text-center mb-12">
      <p className="text-xs font-bold tracking-widest uppercase text-emerald-400 mb-3">Built For Every Career Stage</p>
      <h2 className="text-3xl font-bold text-slate-100 tracking-tight">Who Odyssey Is Designed For</h2>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

      {/* Students — tall left column */}
      <div className="jdc-bento-card md:row-span-2 rounded-2xl border border-amber-800/40 hover:border-amber-500/50 bg-slate-900 p-8 flex flex-col"
        style={{background:"radial-gradient(ellipse at 30% 80%, rgba(251,146,60,0.07) 0%, transparent 60%), #0f172a"}}>
        <div className="flex justify-center py-2 mb-6">
          <AccentStudents/>
        </div>
        <h3 className="text-amber-400 font-bold text-xl tracking-tight mb-3">Students & Graduates</h3>
        <p className="text-slate-300 text-sm leading-relaxed mb-5">
          Enter the market positioned to compete — not just to apply. Turn academic experience into role-ready language that clears ATS filters, earns interviews, and holds up in the room.
        </p>
        <div className="space-y-3 flex-1">
          {["Translate academic projects and internships into measurable, ATS-ready achievements",
            "Identify exactly which skills to build before your first application goes out",
            "Walk into every interview with predicted questions and structured, confident answers"].map((pt,i)=>(
            <div key={i} className="flex items-start gap-3">
              <div className="w-1.5 h-1.5 rounded-full bg-amber-400 mt-1.5 flex-shrink-0"/>
              <p className="text-slate-400 text-sm leading-relaxed">{pt}</p>
            </div>
          ))}
        </div>
        <div className="mt-6 pt-5 border-t border-amber-800/30">
          <div className="flex items-center gap-3 text-xs text-amber-400/60 font-semibold tracking-widest uppercase">
            <div className="w-8 h-0.5 bg-amber-400/30"/> Primary User Group
          </div>
        </div>
      </div>

      {/* Mid-Level Professionals */}
      <div className="jdc-bento-card rounded-2xl border border-violet-800/40 hover:border-violet-500/50 bg-slate-900 p-8 flex flex-col"
        style={{background:"radial-gradient(ellipse at 80% 20%, rgba(168,85,247,0.07) 0%, transparent 60%), #0f172a"}}>
        <div className="flex justify-start mb-5">
          <AccentMidLevel/>
        </div>
        <h3 className="text-violet-400 font-bold text-xl tracking-tight mb-3">Mid-Level Professionals</h3>
        <p className="text-slate-300 text-sm leading-relaxed mb-4">
          You have the depth. The problem is articulating it. Odyssey surfaces your real impact, closes the gap to your target level, and positions you for the role — not just the title.
        </p>
        <div className="mt-auto bg-violet-900/10 border border-violet-800/30 rounded-lg p-3">
          <p className="text-violet-300 text-xs font-semibold mb-1">Key Benefit</p>
          <p className="text-slate-400 text-xs leading-relaxed">Break through the invisible ceiling with a profile that reflects what you're actually worth</p>
        </div>
      </div>

      {/* Career Switchers */}
      <div className="jdc-bento-card rounded-2xl border border-cyan-800/40 hover:border-cyan-500/50 bg-slate-900 p-8 flex flex-col"
        style={{background:"radial-gradient(ellipse at 50% 90%, rgba(34,211,238,0.07) 0%, transparent 60%), #0f172a"}}>
        <div className="flex justify-start mb-5">
          <AccentCareerSwitch/>
        </div>
        <h3 className="text-cyan-400 font-bold text-xl tracking-tight mb-3">Career Switchers</h3>
        <p className="text-slate-300 text-sm leading-relaxed mb-4">
          Your experience isn't irrelevant — it's mis-framed. Odyssey maps your transferable skills to your target domain and positions your pivot as a deliberate, strategic move.
        </p>
        <div className="mt-auto flex items-center gap-6">
          <div className="text-center">
            <div className="text-cyan-400 font-bold text-2xl mb-1">Reframe</div>
            <div className="text-slate-500 text-xs">Your Experience</div>
          </div>
          <div className="w-px h-10 bg-cyan-800/40"/>
          <div className="text-center">
            <div className="text-cyan-400 font-bold text-2xl mb-1">Own</div>
            <div className="text-slate-500 text-xs">The Narrative</div>
          </div>
        </div>
      </div>

      {/* Senior Leaders — wide */}
      <div className="jdc-bento-card md:col-span-2 rounded-2xl border border-emerald-800/35 hover:border-emerald-500/45 bg-slate-900 p-8"
        style={{background:"radial-gradient(ellipse at 90% 50%, rgba(16,185,129,0.07) 0%, transparent 60%), #0f172a"}}>
        <div className="flex flex-col md:flex-row md:items-start md:gap-8">
          <div className="flex-shrink-0 mb-5 md:mb-0 md:pt-1">
            <AccentSenior/>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-emerald-400 font-bold text-xl tracking-tight mb-3">Senior Leaders</h3>
            <p className="text-slate-300 text-sm leading-relaxed mb-5">
              At this level, positioning is everything. Odyssey helps you command the room before you're in it — with executive-grade narrative, precise compensation intelligence, and offer clarity that protects your next move.
            </p>
            <div className="flex flex-wrap gap-2">
              {["Executive Positioning","Compensation Intelligence","Board-Level Readiness","Offer Risk Analysis"].map((tag,i)=>(
                <div key={i} className="px-3 py-1.5 rounded-full bg-emerald-900/20 border border-emerald-800/30">
                  <span className="text-emerald-300 text-xs font-semibold">{tag}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
);

// ── PROCESS FLOW — context-specific accents ───────────────────────────────────
const ProcessFlow = () => {
  const accents = [PfAssess, PfEnhance, PfPractice, PfDecide];
  return (
    <section className="jdc-fade jdc-fade-4">
      <div className="text-center mb-12">
        <p className="text-xs font-bold tracking-widest uppercase text-pink-400 mb-3">Career Intelligence Pipeline</p>
        <h2 className="text-3xl font-bold text-slate-100 tracking-tight">How HEKA Odyssey Works</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {FLOW_STEPS.map((step,i)=>{
          const Accent = accents[i];
          return (
            <div key={i} className="ody-process-card rounded-2xl border border-slate-700/40 bg-slate-900/60 p-7 backdrop-blur-sm overflow-hidden group"
              style={{borderTop:`2px solid ${step.color}35`}}>
              <div className="flex justify-center mb-5 opacity-65 group-hover:opacity-100 transition-opacity duration-300">
                <Accent/>
              </div>
              <div className="text-sm font-bold tracking-widest uppercase mb-2" style={{color:step.color}}>
                {step.label}
              </div>
              <p className="text-slate-300 text-sm leading-relaxed">{step.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

const ComparisonTable = () => (
  <section className="jdc-fade jdc-fade-4">
    <div className="text-center mb-12">
      <h2 className="text-3xl font-bold text-slate-100 tracking-tight mb-4">{COMPARISON.title}</h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
      <div className="jdc-comparison-card rounded-2xl border border-red-800/30 bg-gradient-to-br from-red-900/10 to-slate-900/50 p-8 backdrop-blur-sm group">
        <h3 className="text-red-400 font-bold text-xl mb-6 flex items-center gap-2"><span className="text-2xl">❌</span> {COMPARISON.beforeTitle}</h3>
        <div className="space-y-4">
          {COMPARISON.before.map((item,i)=>(
            <div key={i} className="jdc-comparison-item flex items-start gap-3">
              <Icon d={ICONS.x} size={18} className="text-red-400 flex-shrink-0 mt-0.5 jdc-x-icon"/>
              <p className="text-slate-400 text-sm leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="jdc-comparison-card rounded-2xl border border-emerald-800/30 bg-gradient-to-br from-emerald-900/10 to-slate-900/50 p-8 backdrop-blur-sm group">
        <h3 className="text-emerald-400 font-bold text-xl mb-6 flex items-center gap-2"><span className="text-2xl">✅</span> {COMPARISON.afterTitle}</h3>
        <div className="space-y-4">
          {COMPARISON.after.map((item,i)=>(
            <div key={i} className="jdc-comparison-item flex items-start gap-3">
              <Icon d={ICONS.check} size={18} className="text-emerald-400 flex-shrink-0 mt-0.5 jdc-check-icon" style={{animationDelay:`${i*0.1}s`}}/>
              <p className="text-slate-300 text-sm leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

const CareerTimeline = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(()=>{
    const obs = new IntersectionObserver(([e])=>{ if(e.isIntersecting){ setVisible(true); obs.disconnect(); } },{threshold:0.15});
    if(ref.current) obs.observe(ref.current);
    return ()=>obs.disconnect();
  },[]);

  return (
    <section ref={ref} className="jdc-fade jdc-fade-5">
      <div className="text-center mb-16">
        <p className="text-xs font-bold tracking-widest uppercase text-orange-400 mb-3">Your Journey</p>
        <h2 className="text-3xl font-bold text-slate-100 tracking-tight">The Career Positioning Journey</h2>
        <p className="text-slate-400 mt-4 max-w-xl mx-auto text-sm leading-relaxed">
          Five stages from raw resume to strategic career decision — each powered by targeted intelligence.
        </p>
      </div>

      {/* Desktop */}
      <div className="hidden lg:block relative">
        <div className="absolute top-[20px] left-[5%] right-[5%] h-0.5">
          <div className="h-full w-full bg-gradient-to-r from-orange-500/20 via-violet-500/30 via-cyan-500/30 via-emerald-500/30 to-amber-500/20 ody-glow"/>
        </div>
        <div className="absolute top-[20px] left-[5%] right-[5%] h-0.5 bg-gradient-to-r from-orange-400 via-violet-400 via-cyan-400 via-emerald-400 to-amber-400 origin-left ody-h-timeline-line"/>
        <div className="grid grid-cols-5 gap-4 px-4">
          {TIMELINE_STEPS.map((item,i)=>(
            <div key={i} className="flex flex-col items-center"
              style={{opacity:visible?1:0, transform:visible?'translateY(0)':'translateY(24px)', transition:`all 0.6s ease ${0.5+i*0.15}s`}}>
              <div className="mb-5 w-10 h-10 rounded-full border-2 flex items-center justify-center z-10"
                style={{borderColor:item.nodeColor, backgroundColor:`${item.nodeColor}18`, boxShadow:visible?`0 0 14px ${item.nodeColor}55`:'none', transition:`box-shadow 0.6s ease ${0.7+i*0.15}s`}}>
                <div className="w-3 h-3 rounded-full" style={{backgroundColor:item.nodeColor}}/>
              </div>
              <div className="ody-tl-card w-full rounded-xl p-5 backdrop-blur-sm"
                style={{border:`1px solid ${item.border}`, background:`radial-gradient(ellipse at 50% 0%, ${item.glowColor} 0%, transparent 70%), #0f172acc`}}>
                <div className="text-xs font-bold tracking-widest mb-1.5" style={{color:item.color}}>STAGE {item.step}</div>
                <h4 className="text-slate-100 font-bold text-sm mb-1 leading-tight">{item.title}</h4>
                <div className="text-xs mb-3 font-medium" style={{color:`${item.color}90`}}>{item.subtitle}</div>
                <p className="text-slate-400 text-xs leading-relaxed">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile */}
      <div className="lg:hidden relative pl-8">
        <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gradient-to-b from-orange-400/40 via-violet-400/40 via-cyan-400/40 via-emerald-400/40 to-amber-400/40 jdc-timeline-line"/>
        <div className="space-y-5">
          {TIMELINE_STEPS.map((item,i)=>(
            <div key={i} className="relative"
              style={{opacity:visible?1:0, transform:visible?'translateX(0)':'translateX(-16px)', transition:`all 0.5s ease ${0.3+i*0.12}s`}}>
              <div className="absolute -left-[22px] top-3 w-4 h-4 rounded-full border-2 flex items-center justify-center"
                style={{borderColor:item.nodeColor, backgroundColor:`${item.nodeColor}20`}}>
                <div className="w-1.5 h-1.5 rounded-full" style={{backgroundColor:item.nodeColor}}/>
              </div>
              <div className="jdc-timeline-card rounded-xl p-5 backdrop-blur-sm"
                style={{border:`1px solid ${item.border}`, background:`radial-gradient(ellipse at 0% 50%, ${item.glowColor} 0%, transparent 70%), #0f172acc`}}>
                <div className="text-xs font-bold tracking-widest mb-1" style={{color:item.color}}>{item.title}</div>
                <div className="text-xs mb-2 font-medium" style={{color:`${item.color}80`}}>{item.subtitle}</div>
                <p className="text-slate-400 text-xs leading-relaxed">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const HekaOdyssey = ({ setCurrentPage = () => {} }) => (
  <>
    <style>{styles}</style>
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <div className="space-y-28 max-w-6xl mx-auto px-4 pb-20">

        <section className="relative pt-24 pb-16 text-center jdc-fade jdc-fade-1">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-orange-600/40 bg-orange-900/15 mb-6 backdrop-blur-sm">
            <span className="w-2 h-2 rounded-full bg-orange-400 animate-pulse" />
            <span className="text-orange-400 text-xs font-bold tracking-widest uppercase">Career Intelligence Platform</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-extrabold leading-tight mb-3">
            <span className="vp-title">Heka ODYSSEY</span>
          </h1>
          <p className="text-slate-300 text-2xl md:text-3xl font-bold tracking-wide mt-2 mb-6">
            Chart the Path. Own the Outcome.
          </p>

          <p className="text-slate-400 max-w-2xl mx-auto text-lg leading-relaxed mb-8">
            From resume draft to strategic career positioning — Odyssey analyzes your profile, sharpens your narrative, prepares you for every interview, and guides you through each offer decision with clarity.
          </p>
          <div className="text-sm tracking-wide text-orange-300/70">Built for Candidates, Professionals & Career Changers at Every Stage</div>
        </section>
        
        <div className="jdc-divider"/>
        <FeatureGrid/>
        <div className="jdc-divider"/>
        <BentoCards/>
        <div className="jdc-divider"/>
        <CareerTimeline/>
        <div className="jdc-divider"/>
        <ComparisonTable/>
        <div className="jdc-divider"/>

      {/* ── CTA SECTION ─────────────────────────────────── */}
      <section className="api-fade api-fade-2 text-center p-12 rounded-2xl bg-gradient-to-br from-amber-900/20 to-violet-900/20 border border-amber-800/30 max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-amber-400 mb-4">
          Ready to Transform Your Career Journey?
        </h2>
        <p className="text-violet-300 mb-8 max-w-2xl mx-auto">
          Talk to our team about leveraging Odyssey's career intelligence — 
          from resume optimization and interview prep to offer analysis and career path mapping.
        </p>
        
        <a href="https://wa.me/919235327048?text=Hi%2C%20I%27m%20interested%20in%20HEKA%20Odyssey%20for%20career%20intelligence%20and%20strategic%20positioning.%20I%27d%20like%20to%20learn%20more." 
          target="_blank" rel="noopener noreferrer"
          className="api-btn inline-flex items-center gap-2 bg-amber-600 text-black px-8 py-3 rounded-lg font-bold no-underline text-sm">
          <Icon d={ICONS.whatsapp} size={16} />
          Chat With Our Team
        </a>
      </section>
    </div>
  </div>
  </>
);

export default HekaOdyssey;